/** @format */

const GROQ_CHAT_URL = 'https://api.groq.com/openai/v1/chat/completions';

export const groqApiKey: string | undefined = process.env.REACT_APP_GROQ_API_KEY;

/** Default model: fast Llama 3.1 8B on GroqCloud (see https://console.groq.com/docs/models). */
export const groqModel: string = process.env.REACT_APP_GROQ_MODEL ?? 'llama-3.1-8b-instant';

/** ~30 lines × ~80 tokens is enough; smaller body avoids strict proxy limits. */
export const groqGenerationDefaults = {
	temperature: 1,
	top_p: 0.95,
	max_tokens: 4096
} as const;

type GroqChatResponse = {
	choices?: Array<{ message?: { content?: string | null } }>;
	error?: { message?: string };
};

/**
 * Single-turn chat completion (OpenAI-compatible Groq endpoint).
 */
export async function groqChatCompletion(userContent: string | string[]): Promise<string> {
	const apiKey = groqApiKey;
	if (!apiKey) {
		throw new Error('Missing REACT_APP_GROQ_API_KEY');
	}

	const userText = Array.isArray(userContent) ? userContent.join('\n') : userContent;

	const res = await fetch(GROQ_CHAT_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${apiKey}`
		},
		body: JSON.stringify({
			model: groqModel,
			messages: [
				{
					role: 'system',
					content: 'Output only the requested lines. No markdown, no preamble.'
				},
				{ role: 'user', content: userText }
			],
			...groqGenerationDefaults
		})
	});

	const data = (await res.json()) as GroqChatResponse;

	if (!res.ok) {
		const msg = data.error?.message ?? `HTTP ${res.status}`;
		throw new Error(msg);
	}

	const text = data.choices?.[0]?.message?.content;
	if (typeof text !== 'string') {
		throw new Error('Unexpected response from Groq API');
	}
	return text;
}
